import React from "react";
import { StyledImageContainer } from './styled';

function NotFound() {
  return (
    <StyledImageContainer>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 512 512"
      >
        <path
          fill="#f4fbff"
          d="M407.935 512h-303.87c-17.242 0-31.22-13.977-31.22-31.22V83.252h366.309V480.78c0 17.243-13.977 31.22-31.219 31.22z"
        ></path>
        <path
          fill="#ddeafb"
          d="M403.772 83.252V480.78c0 17.242-13.977 31.22-31.22 31.22h35.382c17.242 0 31.22-13.977 31.22-31.22V83.252z"
        ></path>
        <path
          fill="#5766cb"
          d="M407.935 0h-303.87c-17.242 0-31.22 13.977-31.22 31.22v52.033h366.309V31.22c0-17.243-13.977-31.22-31.219-31.22z"
        ></path>
        <path
          fill="#3d4fc3"
          d="M407.935 0h-35.382c17.242 0 31.22 13.977 31.22 31.22v52.033h35.382V31.22C439.154 13.977 425.177 0 407.935 0z"
        ></path>
        <path
          fill="#e28086"
          d="M211.226 144.404l-57.822 92.24c-22.019 35.126 3.23 80.755 44.688 80.755h115.644c41.457 0 66.707-45.629 44.688-80.755l-57.822-92.24c-20.67-32.972-68.707-32.972-89.376 0z"
        ></path>
        <path
          fill="#dd636e"
          d="M358.423 236.643l-41.076-65.526a135.351 135.351 0 011.857 22.338c0 55.728-33.894 103.539-82.192 123.944h76.724c41.457-.001 66.706-45.63 44.687-80.756z"
        ></path>
        <path
          fill="#f4fbff"
          d="M282.164 233.106l10.043-10.043c7.226-7.225 7.226-18.939 0-26.164-7.224-7.224-18.939-7.224-26.163 0L256 206.942l-10.044-10.044c-7.224-7.224-18.939-7.224-26.163 0-7.226 7.225-7.226 18.939 0 26.164l10.043 10.043-10.043 10.043c-7.226 7.225-7.226 18.939 0 26.164 3.612 3.612 8.347 5.418 13.082 5.418s9.469-1.806 13.082-5.418L256 259.269l10.044 10.044c3.612 3.612 8.347 5.418 13.082 5.418s9.469-1.806 13.082-5.418c7.226-7.225 7.226-18.939 0-26.164z"
        ></path>
        <path
          fill="#e28086"
          d="M373.91 473.938h-.067a7.727 7.727 0 01-7.66-7.792c.059-6.866.121-14.597.177-22.614h-43.743a7.725 7.725 0 01-6.766-11.458c5.777-10.47 34.884-63.058 40.683-70.173 6.278-7.7 12.914-6.688 15.477-5.894 5.436 1.684 9.304 7.054 9.856 13.682.309 3.713.205 32.914.049 58.391h5.396a7.726 7.726 0 110 15.452h-5.499c-.08 11.268-.155 20.059-.178 22.747a7.726 7.726 0 01-7.725 7.659zm-38.176-45.86h30.727c.138-22.812.214-44.947.102-53.584-5.615 8.764-19.592 33.408-30.829 53.584zM176.547 473.938h-.068a7.725 7.725 0 01-7.659-7.792c.059-6.867.12-14.597.177-22.614h-43.743a7.725 7.725 0 01-6.765-11.458c5.776-10.47 34.884-63.058 40.683-70.173 6.277-7.702 12.914-6.688 15.476-5.895 5.435 1.684 9.304 7.054 9.857 13.682.309 3.714.206 32.915.05 58.392h5.396a7.726 7.726 0 110 15.452h-5.499c-.081 11.268-.155 20.059-.179 22.747a7.73 7.73 0 01-7.726 7.659zm-38.176-45.86h30.727c.138-22.812.214-44.947.102-53.584-5.617 8.764-19.593 33.408-30.829 53.584zM255.957 473.938c-20.043 0-36.35-16.307-36.35-36.35v-45.777c0-20.043 16.307-36.35 36.35-36.35 20.044 0 36.351 16.307 36.351 36.35v45.777c0 20.043-16.307 36.35-36.351 36.35zm0-103.025c-11.523 0-20.897 9.375-20.897 20.897v45.777c0 11.523 9.375 20.897 20.897 20.897 11.524 0 20.898-9.375 20.898-20.897V391.81c0-11.522-9.374-20.897-20.898-20.897z"
        ></path>
        <circle cx="389.203" cy="41.626" r="13.528" fill="#95d6a4"></circle>
        <circle cx="343.415" cy="41.626" r="13.528" fill="#ffe07d"></circle>
        <circle cx="297.626" cy="41.626" r="13.528" fill="#e28086"></circle>
      </svg>
    </StyledImageContainer>
  );
}

export default NotFound;
